import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, normalizeClass as _normalizeClass, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "v-select-calendar__header" }
const _hoisted_2 = { class: "month" }
const _hoisted_3 = { class: "v-select-calendar__table" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "v-select-calendar__actions" }

import { ref, watch, computed, shallowRef, nextTick } from 'vue';
import { useUiStore } from '@/stores/ui';
import VSelect from './VSelect.vue';
import CalendarIcon from './icons/other/CalendarIcon.vue';
import CustomIcon from './icons/other/CustomIcon.vue';
import ChevronLeftIcon from './icons/navigation/ChevronLeftIcon.vue';
import ChevronRightIcon from './icons/navigation/ChevronRightIcon.vue';
import VIconButton from './VIconButton.vue';
import dayjs from 'dayjs';
import VButton from './VButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VDatePicker',
  props: {
    modelValue: null
  },
  emits: [ "update:modelValue" ],
  setup(__props: any, { emit }) {

const props = __props as { modelValue?: string }




const uiStore = useUiStore()
const period = computed({
  get() {
    return (props.modelValue as typeof uiStore.period) ?? uiStore.period
  }, 
  set(period: typeof uiStore.period) {
    if (props.modelValue) {
      emit("update:modelValue", period)
    } else {
      uiStore.period = period
    }
  }
})

const mode = ref<'select' | 'calendar'>('select')

const weekItems =  [
  { id: "today", title: "Today" },
  { id: "yesterday", title: "Yesterday" },
  { id: "week", title: "This week" },
  { id: "month", title: "This month" },
  { id: "year", title: "This year" },
  { id: "all", title: "All time" },
  { id: "custom", title: "Time period", icon: CustomIcon }
]

const yearItems = [
  { id: "2022", title: "2022" },
  { id: "2023", title: "2023" }
]
const yearValue = ref("2023")

const vSelectRef = ref()

const currentMonth = shallowRef(dayjs().startOf("month"))
const weekValues = [ "Su", "Mo", "Tu", "We", "Th", "Fr", "Sa" ]
const calendarValues = computed(() => {
  const arr = []
  let item: ({ title: string, date: dayjs.Dayjs, otherMonth?: boolean })[] = []

  for (let i = currentMonth.value.day(); i > 0; i--) {
    const date = currentMonth.value.add(-i, "day")
    item.push({ title: date.format("D"), date, otherMonth: true })
  }
  const daysInMonth = currentMonth.value.daysInMonth()
  for (let i = 0; i < daysInMonth; i++) {
    item.push({ title: (i+1).toString(), date: currentMonth.value.date(i+1) })
    if (item.length === 7) {
      arr.push(item)
      item = []
    }
  }
  if (item.length > 0) {
    const lastDate = item[item.length-1].date
    for (let i = 1; i < 7-lastDate.day(); i++) {
      const date = lastDate.add(i, "day")
      item.push({ title: date.format("D"), date, otherMonth: true })
    }
    arr.push(item)
  }
  return arr
})

const onClose = () => {
  mode.value = 'select'
}

const startDate = shallowRef<dayjs.Dayjs | null>(null)
const endDate = shallowRef<dayjs.Dayjs | null>(null)

const isHighlighted = computed(() => {
  if (!startDate.value || !endDate.value) return false
  if (startDate.value.isSame(endDate.value)) return false
  return true
})

const onItemClick = (cell: { title: string, date: dayjs.Dayjs }) => {
  if (!cell) return
  if (startDate.value && endDate.value) {
    endDate.value = null
    startDate.value = null
  }
  if(startDate.value) { 
    endDate.value = cell.date
    if (endDate.value.unix() < startDate.value.unix()) {
      endDate.value = startDate.value
      startDate.value = cell.date
    }
    return
  }
  startDate.value = cell.date
}

const setMonth = (inc: number) => {
  currentMonth.value = currentMonth.value.add(inc, "month")
}

const setYear = (year: string) => {
  currentMonth.value = currentMonth.value.set("year", parseInt(year))
}

const setPeriod = (value: typeof uiStore.period) => {
  if (value === "custom") {
    nextTick(() => {
      vSelectRef.value.preventClose()
      mode.value = 'calendar'
    })
    return
  }
  period.value = value
}

const applyCalendar = () => {
  if (!startDate.value || !endDate.value) return
  period.value = "custom"
  uiStore.customDate = [ startDate.value , endDate.value ]
  vSelectRef.value.close()
}

const cancel = () => {
  mode.value = "calendar"
  vSelectRef.value.close()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VSelect, {
    ref_key: "vSelectRef",
    ref: vSelectRef,
    "model-value": _unref(period),
    class: "ml-2 week",
    items: mode.value === 'select'? weekItems: [],
    placement: "end",
    "onUpdate:modelValue": setPeriod,
    onClose: onClose
  }, _createSlots({
    default: _withCtx(() => [
      _createVNode(CalendarIcon),
      (_unref(period) !== 'custom')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(weekItems.find(item => item.id === _unref(period) )?.title), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_unref(uiStore).customDate![0].format("MM.DD")) + " - " + _toDisplayString(_unref(uiStore).customDate![1].format("MM.DD")), 1)
          ], 64))
    ]),
    _: 2
  }, [
    (mode.value === 'calendar')
      ? {
          name: "top",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(VSelect, {
                "model-value": _unref(currentMonth).format('YYYY'),
                "onUpdate:modelValue": setYear,
                items: yearItems
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(currentMonth).format("YYYY")), 1)
                ]),
                _: 1
              }, 8, ["model-value"]),
              _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(currentMonth).format("MMMM")), 1),
              _createVNode(VIconButton, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (setMonth(-1)))
              }, {
                default: _withCtx(() => [
                  _createVNode(ChevronLeftIcon)
                ]),
                _: 1
              }),
              _createVNode(VIconButton, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (setMonth(1)))
              }, {
                default: _withCtx(() => [
                  _createVNode(ChevronRightIcon)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("table", _hoisted_3, [
              _createElementVNode("thead", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekValues, (item) => {
                  return _createElementVNode("th", null, _toDisplayString(item), 1)
                }), 64))
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(calendarValues), (row) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell) => {
                      return (_openBlock(), _createElementBlock("td", {
                        onClick: ($event: any) => (onItemClick(cell)),
                        class: _normalizeClass({ 
                otherMonth: cell?.otherMonth,
                active: cell?.date.isSame(_unref(startDate)) || cell?.date.isSame(_unref(endDate)),
                highlightStart: _unref(isHighlighted) && cell?.date.isSame(_unref(startDate)), 
                highlightEnd: _unref(isHighlighted) && cell?.date.isSame(_unref(endDate)),
                highlight: cell?.date.isAfter(_unref(startDate)) && cell?.date.isBefore(_unref(endDate)) 
              })
                      }, _toDisplayString(cell?.title), 11, _hoisted_4))
                    }), 256))
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(VButton, {
                disabled: !_unref(startDate) || !_unref(endDate),
                onClick: applyCalendar
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Show results")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(VButton, {
                secondary: "",
                onClick: cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              })
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["model-value", "items"]))
}
}

})